// ProductsSpecs.js
import React, { useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./ProductsSpecs.css";

function get_specification_name(alldeviceData, key) {
  function searchObject(obj) {
      if (obj && typeof obj === 'object') {
          if (obj.hasOwnProperty(key) && obj[key]?.hasOwnProperty("specification_name")) {
              return obj[key].specification_name;
          }
          for (const k in obj) {
              if (typeof obj[k] === 'object' && obj[k] !== null) {
                  const result = searchObject(obj[k]);
                  if (result) return result;
              }
          }
      }
      return null;
  }
  return searchObject(alldeviceData);
}

let hashSpesc = null;


const ProductsSpecs = ({ deviceData, url, showDifferencesOnly, labels, hashmapSpecifications, allData }) => {
  hashSpesc = hashmapSpecifications
  const [tabValue, setTabValue] = useState(0);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  
  // تأكد من وجود بيانات الأجهزة
  if (!deviceData || !deviceData.items || deviceData.items.length < 2) {
    return (
      <Typography variant="h6" style={{ marginTop: 20 }}>
        Please select at least two devices to compare.
      </Typography>
    );
  }

  return (
    <div className="ProductsSpecs">
      <Box className="ProductsSpecs-container no-shadow">
        {/* Tabs للتبديل بين المواصفات التقنية والميزات */}
        <Tabs
          value={tabValue}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="product specifications tabs"
          className="no-shadow"
          TabIndicatorProps={{
            style: { backgroundColor: "#239DAB" },
          }}
        >
          {
            Object.keys(allData.specifications).length > 0 && (
              <Tab
                label="Technical Specifications"
                sx={{
                  "&.Mui-selected": { color: "#239DAB" },
                }}
              />
            )
          }
          {
            Object.keys(allData.features).length > 0 && (
              <Tab
                label="Features"
                sx={{
                  "&.Mui-selected": { color: "#239DAB" },
                }}
              />
            )
          }
        
          
          
          
        </Tabs>

        <Box className="tab-content no-shadow">
          {/* تبويب المواصفات */}
          {tabValue === 0 && (
            <AccordionSections
              devices={deviceData.items}
              specsType="specifications"
              url={url}
              showDifferencesOnly={showDifferencesOnly}
              labels={labels}
              alldeviceData={deviceData}
              hashmapSpecifications={hashmapSpecifications}
            />
          )}

          {/* تبويب الميزات */}
          {tabValue === 1 && (
            <AccordionSections
              devices={deviceData.items}
              specsType="features"
              url={url}
              showDifferencesOnly={showDifferencesOnly}
              labels={labels}
              alldeviceData={deviceData}
            />
          )}
        </Box>
      </Box>
    </div>
  );
};

const AccordionSections = ({
  devices,
  specsType,
  url,
  showDifferencesOnly,
  labels,
  alldeviceData,
  hashmapSpecifications
}) => {
  
  if (!devices || devices.length === 0) {
    return <Typography>No data available.</Typography>;
  }

  // Collect all categories from all devices for the given specsType
  const allCategories = devices.reduce((acc, device) => {
    const deviceSpecs = device?.[specsType];
    if (deviceSpecs) {
      Object.keys(deviceSpecs).forEach(category => acc.add(category));
    }
    return acc;
  }, new Set());

  if (allCategories.size === 0) {
    return <Typography>No data available.</Typography>;
  }

  // Helper function to check if a category has data to display
  const hasComparisonData = (
    devices,
    specsType,
    category,
    showDifferencesOnly
  ) => {
    // Collect all keys from all devices in this category
    const keys = devices.reduce((acc, device) => {
      const categoryData = device?.[specsType]?.[category];
      if (categoryData) {
        Object.keys(categoryData).forEach(key => acc.add(key));
      }
      return acc;
    }, new Set());

    if (keys.size === 0) return false;

    const filteredKeys = Array.from(keys).filter((key) => {
      if (!showDifferencesOnly) return true;

      const values = devices.map(
        (device) => device?.[specsType]?.[category]?.[key]
      );

      const nonNullValues = values.filter((val) => val !== undefined);
      // #omarg
      // Show if only value is explicitly `null`
      // fix for comparing no info with no info ...
      // or no info with null
      if (
        showDifferencesOnly && 
        nonNullValues.length === 1 &&
        nonNullValues[0] === null
      ) {
        return false; // ❌ Do not include this key in filtered list
      }
      // else contunie code normally
      if (nonNullValues.length < 2) return true;

      const allValuesEqual = nonNullValues.every((val) =>
        deepEqual(val, nonNullValues[0])
      );

      // Fix for comparing items that are lists
      // this ignores the order of the comparison
      if (!allValuesEqual) {
        try {
          const normalized = nonNullValues.map(arr =>
            [...new Set(arr)].sort()
          );
          const new_allValuesEqual = normalized.every((val) =>
            deepEqual(val, normalized[0])
          );
          return !new_allValuesEqual;
        } catch (err) {
          // Fallback to default comparison
          console.log("error while normalizing")
        }
      }

      return !allValuesEqual;
    });

    return filteredKeys.length > 0;
  };

  return (
    <>
      {Array.from(allCategories).map((category, index) => {
        const hasData = hasComparisonData(
          devices,
          specsType,
          category,
          showDifferencesOnly
        );

        if (!hasData) return null;

        return (
          <Accordion
            key={index}
            className="custom-accordion no-shadow"
            defaultExpanded={index === 0}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">
                {get_specification_name(alldeviceData[specsType], category)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <ComparisonTable
                devices={devices}
                specsType={specsType}
                category={category}
                url={url}
                showDifferencesOnly={showDifferencesOnly}
                labels={labels}
                alldeviceData={alldeviceData}
                hashmapSpecifications={hashmapSpecifications}
              />
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};

const deepEqual = (a, b) => {
  if (a === b) return true;

  if (typeof a !== typeof b) return false;

  if (typeof a === "object" && a !== null && b !== null) {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;

    for (let key of keysA) {
      if (!deepEqual(a[key], b[key])) return false;
    }
    return true;
  }
  return false;
};


const ComparisonTable = ({
  devices,
  specsType,
  category,
  url,
  showDifferencesOnly,
  labels,
  alldeviceData,
  hashmapSpecifications
}) => {
  // omarg 
  // this code does not show compared items if the key is not included in the first item.
  // this causes alot of specifications to be hidden in comparison
  // // العثور على أول جهاز يحتوي على بيانات لهذا القسم
  // const firstDeviceWithData = devices.find(
  //   (device) => device?.[specsType]?.[category]
  // );

  // if (!firstDeviceWithData) {
  //   return null;
  // }

  // // الحصول على جميع المفاتيح لهذا القسم
  // const keys = Object.keys(firstDeviceWithData[specsType][category]);

  // this code instead collects all keys from devices.
  const keysSet = new Set();

  devices.forEach((device) => {
    const categoryData = device?.[specsType]?.[category];
    if (categoryData) {
      Object.keys(categoryData).forEach((key) => keysSet.add(key));
    }
  });

  // Convert Set to Array
  const keys = Array.from(keysSet);

  if (keys.length === 0) {
    return null;
  }

  // تصفية المفاتيح إذا كان خيار "إظهار الاختلافات فقط" مفعلاً
  const filteredKeys = keys.filter((key) => {
    if (!showDifferencesOnly) return true;

    const values = devices.map(
      (device) => device?.[specsType]?.[category]?.[key]
    );

    const nonNullValues = values.filter((val) => val !== undefined);
    // #omarg
    // Show if only value is explicitly `null`
    // fix for comparing no info with no info ...
    // or no info with null
    if (
      showDifferencesOnly && 
      nonNullValues.length === 1 &&
      nonNullValues[0] === null
    ) {
      return false; // ❌ Do not include this key in filtered list
    }
    // else contunie code normally
    if (nonNullValues.length < 2) return true; // إذا كان أقل من جهازين يحتويان على القيمة، نظهرها

    const allValuesEqual = nonNullValues.every((val) =>
      deepEqual(val, nonNullValues[0])
    );

    // Fix for comparing items that are lists
    // this ignores the order of the comparison
    if (!allValuesEqual) {
      try {
        const normalized = nonNullValues.map(arr =>
          [...new Set(arr)].sort()
        );
        const new_allValuesEqual = normalized.every((val) =>
          deepEqual(val, normalized[0])
        );
        return !new_allValuesEqual;
      } catch (err) {
        // Fallback to default comparison
        console.log("error while normalizing")
      }
    }

    return !allValuesEqual;
  });

  // omarg
  // sort keys because previous function changes the key order
  // this causes an issue with Features
  // TODO
  // hashmapSpecifications does not exist in features.
  if (hashmapSpecifications !== undefined){
    filteredKeys.sort((a, b) => {
      const orderA = hashmapSpecifications[a]?.order ?? Infinity;
      const orderB = hashmapSpecifications[b]?.order ?? Infinity;
      return orderA - orderB;
    });
  }
  

  // إذا لم يكن هناك مفاتيح لعرضها، نعيد null
  if (filteredKeys.length === 0) {
    return null;
  }

  // عرض الجدول كالسابق
  return (
    <table className="comparison-table">
      <thead>
        <tr>
          <th>Feature / Specification</th>
          {devices.map((device, index) => (
            <th key={index}>
              {device ? device.web_item_name || device.name : ""}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
      {filteredKeys.length > 0 ? (
        filteredKeys.map((key, index) =>
          renderRow(
            key,
            devices,
            specsType,
            category,
            url,
            index,
            showDifferencesOnly,
            labels,
            alldeviceData
          )
        )
      ) : (
        <tr>
          <td colSpan="100%">Products Contain no Data to Compare!</td>
        </tr>
      )}
        
      </tbody>
    </table>
  );
};
const renderRow = (
  key,
  devices,
  specsType,
  category,
  url,
  index,
  showDifferencesOnly,
  labels,
  alldeviceData
) => {
  const firstDeviceValue = devices.find(
    (device) => device?.[specsType]?.[category]?.[key] !== undefined
  )?.[specsType]?.[category]?.[key];

  // Collect values for this key across devices
  const values = devices.map(
    (device) => device?.[specsType]?.[category]?.[key]
  );

  // If showDifferencesOnly is true and all values are equal, skip rendering this row
  const nonNullValues = values.filter((val) => val !== undefined);
  if (
    showDifferencesOnly &&
    nonNullValues.length > 1 &&
    nonNullValues.every((val) => deepEqual(val, nonNullValues[0]))
  ) {
    return null;
  }

  
// If the value is nested (an object), render sub-rows
if (
  (typeof firstDeviceValue === "object" &&
    !Array.isArray(firstDeviceValue) &&
    firstDeviceValue !== null) ||
  devices.some(device => {
    const itemValue = device?.[specsType]?.[category]?.[key];
    return typeof itemValue === "object" && 
           !Array.isArray(itemValue) && 
           itemValue !== null;
  })
) {
  // Get all subKeys by looking through all devices, not just the first one
  const allSubKeys = devices.reduce((acc, device) => {
    const deviceItemValue = device?.[specsType]?.[category]?.[key];
    
    // Ignore array of arrays (like [["cd46ugr3fu"], ["cd46al8r76"]])
    if (Array.isArray(deviceItemValue) && 
        deviceItemValue.every(item => Array.isArray(item))) {
      return acc; // Skip this device
    }

    // Get keys if the value is an object
    const deviceKeys = deviceItemValue && !Array.isArray(deviceItemValue)
      ? Object.keys(deviceItemValue)
      : [];

    return [...new Set([...acc, ...deviceKeys])]; // Combine and keep only unique keys
  }, []);

  // Filter subKeys if showDifferencesOnly is true
  const filteredSubKeys = allSubKeys.filter((subKey) => {
    if (!showDifferencesOnly) return true;

    const subValues = devices.map(
      (device) => device?.[specsType]?.[category]?.[key]?.[subKey]
    );

    const nonNullSubValues = subValues.filter((val) => val !== undefined);
    // // #omarg
    // // Show if only value is explicitly `null`
    // // fix for comparing no info with no info ...
    // if (
    //   nonNullSubValues.length === 1 &&
    //   nonNullSubValues[0] === null
    // ) {
    //   return false; // ❌ Do not include this key in filtered list
    // }
    // // else contunie code normally

    if (nonNullSubValues.length < 2) return true;

    // Check if all subValues are equal
    const allSubValuesEqual = nonNullSubValues.every((val) =>
      deepEqual(val, nonNullSubValues[0])
    );

    return !allSubValuesEqual;
  });

  if (filteredSubKeys.length === 0) {
    return null;
  }

  return (
    <React.Fragment key={`nested-${index}`}>
      <tr className="parent-row">
        <td colSpan={devices.length + 1}>{get_specification_name(alldeviceData[specsType], key)}</td>
      </tr>
      {filteredSubKeys.map((subKey, subIndex) => (
        <tr key={`sub-${index}-${subIndex}`} className="child-row">
          <td>
            {get_specification_name(alldeviceData[specsType], subKey) != null ? 
              get_specification_name(alldeviceData[specsType], subKey) : 
              subKey}
          </td>
          {devices.map((device, idx) => (
            <td key={idx}>
              {device
                ? renderValue(
                    device?.[specsType]?.[category]?.[key]?.[subKey],
                    url,
                    key,
                    labels,
                    subKey
                  )
                : ""}
            </td>
          ))}
        </tr>
      ))}
    </React.Fragment>
  );
}


  // If the value is simple, render a single row
  return (
    <tr key={`simple-${index}`}>
      <td>{get_specification_name(alldeviceData[specsType], key) != null ? get_specification_name(alldeviceData[specsType], key) : key}</td>
      {devices.map((device, idx) => (
        <td key={idx}>
          {device
            ? renderValue(device?.[specsType]?.[category]?.[key], url, key, labels) // تمرير المفتاح الأب
            : ""}
        </td>
      ))}
    </tr>
  );
};




// const renderRow = (
//   key,
//   devices,
//   specsType,
//   category,
//   url,
//   index,
//   showDifferencesOnly
// ) => {
//   const firstDeviceValue = devices.find(
//     (device) => device?.[specsType]?.[category]?.[key] !== undefined
//   )?.[specsType]?.[category]?.[key];

//   // Collect values for this key across devices
//   const values = devices.map(
//     (device) => device?.[specsType]?.[category]?.[key]
//   );

//   // If showDifferencesOnly is true and all values are equal, skip rendering this row
//   const nonNullValues = values.filter((val) => val !== undefined);
//   if (
//     showDifferencesOnly &&
//     nonNullValues.length > 1 &&
//     nonNullValues.every((val) => deepEqual(val, nonNullValues[0]))
//   ) {
//     return null;
//   }

//   // If the value is nested (an object), render sub-rows
//   if (
//     typeof firstDeviceValue === "object" &&
//     !Array.isArray(firstDeviceValue) &&
//     firstDeviceValue !== null
//   ) {
//     // Get all subKeys
//     const subKeys = Object.keys(firstDeviceValue);

//     // Filter subKeys if showDifferencesOnly is true
//     const filteredSubKeys = subKeys.filter((subKey) => {
//       if (!showDifferencesOnly) return true;

//       const subValues = devices.map(
//         (device) => device?.[specsType]?.[category]?.[key]?.[subKey]
//       );

//       const nonNullSubValues = subValues.filter((val) => val !== undefined);
//       if (nonNullSubValues.length < 2) return true;

//       // Check if all subValues are equal
//       const allSubValuesEqual = nonNullSubValues.every((val) =>
//         deepEqual(val, nonNullSubValues[0])
//       );

//       return !allSubValuesEqual;
//     });

//     if (filteredSubKeys.length === 0) {
//       return null;
//     }

//     return (
//       <React.Fragment key={`nested-${index}`}>
//         <tr className="parent-row">
//           <td colSpan={devices.length + 1}>{key}</td>
//         </tr>
//         {filteredSubKeys.map((subKey, subIndex) => (
//           <tr key={`sub-${index}-${subIndex}`} className="child-row">
//             <td>{subKey}</td>
//             {devices.map((device, idx) => (
//               <td key={idx}>
//                 {device
//                   ? renderValue(
//                       device?.[specsType]?.[category]?.[key]?.[subKey],
//                       url
//                     )
//                   : ""}
//               </td>
//             ))}
//           </tr>
//         ))}
//       </React.Fragment>
//     );
//   }

//   // If the value is simple, render a single row
//   return (
//     <tr key={`simple-${index}`}>
//       <td>{key}</td>
//       {devices.map((device, idx) => (
//         <td key={idx}>
//           {device
//             ? renderValue(device?.[specsType]?.[category]?.[key], url)
//             : ""}
//         </td>
//       ))}
//     </tr>
//   );
// };


const renderValue = (value, url, parentKey, labels, child_key = null) => {
  if (value === null || value === undefined) {
    return <span>{value === null ? "No Info" : "-"}</span>
  }

  // إذا كانت القيمة 0 أو 1
  if (typeof value === "boolean") {
    if (value === true) {
      return "Yes"
    } else {
      return "No"
    }
    ;
  }
 

  // إذا كان المفتاح يحتوي على "datetime range"
  if (
    typeof value === "object" &&
    value !== null &&
    parentKey &&
    parentKey.toLowerCase().includes("datetime range")
  ) {
    const minDate = new Date(value.min * 1000); // تحويل القيمة الدنيا إلى تاريخ
    const maxDate = new Date(value.max * 1000); // تحويل القيمة العليا إلى تاريخ
    return `${minDate.toLocaleString()} - ${maxDate.toLocaleString()}`;
  }

  // إذا كان المفتاح يحتوي على "datetime"
  if (
    typeof value === "number" &&
    parentKey &&
    parentKey.toLowerCase().includes("datetime")
  ) {
    const date = new Date(value * 1000); // ضرب القيمة لتحويل الثواني إلى ميلي ثانية
    return date.toLocaleString();
  }

  // إذا كان المفتاح يحتوي على "time range"
  if (
    typeof value === "object" &&
    value !== null &&
    parentKey &&
    parentKey.toLowerCase().includes("time range")
  ) {
    const minTime = new Date(value.min * 1000).toLocaleTimeString(); // تحويل القيمة الدنيا إلى وقت
    const maxTime = new Date(value.max * 1000).toLocaleTimeString(); // تحويل القيمة العليا إلى وقت
    return `${minTime} - ${maxTime}`;
  }

  // إذا كان المفتاح يحتوي على "time"
  if (
    typeof value === "number" &&
    parentKey &&
    parentKey.toLowerCase().includes("time")
  ) {
    const time = new Date(value * 1000).toLocaleTimeString(); // تحويل القيمة إلى وقت
    return time;
  }

  // إذا كانت القيمة مسار ملف
  if (typeof value === "string" && value.startsWith("/files/")) {
    const src = url ? `${url}${value}` : value;
    return (
      <img
        src={src}
        alt="file"
        style={{ maxWidth: "100px", maxHeight: "100px" }}
      />
    );
  }

  // إذا كانت القيمة مصفوفة
  if (Array.isArray(value)) {
    return value.length > 0 ? (
      value.map((item, index) => (
        <span key={index}>
          {labels[item] !== undefined ? labels[item] : item} {/* Check if item exists in labels */}
          {index !== value.length - 1 && ", "}
        </span>
      ))
    ) : (
      <span className="">No Info</span>
    );
  }
  
  

  // إذا كانت القيمة كائنًا
  if (typeof value === "object" && value !== null) {
    const filteredEntries = Object.entries(value).filter(
      ([key, subValue]) => {
        // Check if key or value is in labels
        const newKey = labels[key] || key;
        const newValue = Array.isArray(subValue)
          ? subValue.map(item => labels[item] || item) // Replace items in the array with labels if applicable
          : typeof subValue === "object" && subValue !== null
          ? Object.entries(subValue).reduce((acc, [subKey, subVal]) => {
              acc[labels[subKey] || subKey] = labels[subVal] || subVal; // Replace keys and values in nested objects
              return acc;
            }, {})
          : labels[subValue] || subValue; // Replace value if in labels
        
        // omarg
        // allow showing all items as long as they are objects
        // this is for example, item with 5G enabled, but no 5g mode is choosen, it should show that it has 5g.
        return true;
        // // Filter out empty objects or arrays
        // return !(
        //   (Array.isArray(subValue) && subValue.length === 0) ||
        //   (typeof subValue === "object" &&
        //     subValue !== null &&
        //     Object.keys(subValue).length === 0)
        // );
      }
    );
  
    if (filteredEntries.length === 0) {
      return <span className="">No Info</span>;
    }
  
    return (
      <ul style={{ margin: 0, paddingLeft: "20px", listStyle: "disc" }}>
        {filteredEntries.map(([key, subValue], idx) => {
          // Replace key with label if it exists
          const displayKey = labels[key] || key;
          return (
            <li key={idx}>
              <strong>{displayKey}:</strong> {renderValue(subValue, url, key, labels)}
            </li>
          );
        })}
      </ul>
    );
  }

  

  // console.log("speeeeeeeeccccc", hashSpesc)
  // console.log("hashhhhhhhhhhhh", hashSpesc[parentKey])
  // console.log("valueeeeeeeeeee", value)

  // if ((hashSpesc[parentKey]?.field_type && !hashSpesc[parentKey]?.field_type.includes("Range")) || !hashSpesc[parentKey]?.children) {
  if (hashSpesc[parentKey]?.has_context && ["Number", "Float"].includes(hashSpesc[parentKey]?.field_type)) {
    // console.log(hashSpesc[parentKey]?.specification_name)
    let _context = hashSpesc[parentKey]?.context;
    const uom =
      hashSpesc[parentKey]?.uom_abbr
        ? hashSpesc[parentKey]?.uom_abbr
        : hashSpesc[parentKey]?.uom;
  
   
    if (_context) {
      const uomSpan = uom ? ` <span class='compare-uom'>${uom}</span>` : '';
      _context = _context.replace(
        `{${hashSpesc[parentKey].specification_name}}`,
        `${value}${uomSpan}`
      );
    }
    else {
      _context = value;
    }
    return (
      <span className="children-details" dangerouslySetInnerHTML={{ __html: _context }} />
    );
  }
  
  
  // عرض القيمة إذا كانت موجودة أو عرض خلية فارغة
  return value !== undefined && value !== null ? (
    
    
    labels[value] !== undefined ? (
      `${labels[value]}`
      
    ) : (
      <>
        {value.toString()}{" "}
        <span className="compare-uom">
         
          { 
            hashSpesc[parentKey]?.children ? (
             hashSpesc[parentKey]?.children[child_key]?.uom_abbr || hashSpesc[parentKey]?.children[child_key]?.uom || ""
            ) : (
                hashSpesc[parentKey]?.uom_abbr || hashSpesc[parentKey]?.uom || ""
            )
          }
          
        
        </span>
      </>
      
    )
  ) : (
    <span className="">No Info</span>
  );
  


  
  

};







// const renderValue = (value, url) => {
//   if (value === 0) return "No";
//   if (value === 1) return "Yes";

//   if (typeof value === "string" && value.startsWith("/files/")) {
//     const src = url ? `${url}${value}` : value;
//     return (
//       <img
//         src={src}
//         alt="file"
//         style={{ maxWidth: "100px", maxHeight: "100px" }}
//       />
//     );
//   }

//   if (Array.isArray(value)) {
//     return value.length > 0 ? (
//       value.map((item, index) => (
//         <span key={index}>
//           {item}
//           {index !== value.length - 1 && ", "}
//         </span>
//       ))
//     ) : (
//       <span className="empty-cell"></span>
//     );
//   }

//   if (typeof value === "object" && value !== null) {
//     // If the value is an object, render its entries recursively
//     const filteredEntries = Object.entries(value).filter(
//       ([_, subValue]) =>
//         !(
//           (Array.isArray(subValue) && subValue.length === 0) ||
//           (typeof subValue === "object" &&
//             subValue !== null &&
//             Object.keys(subValue).length === 0)
//         )
//     );

//     if (filteredEntries.length === 0) {
//       return <span className="empty-cell"></span>;
//     }

//     return (
//       <ul style={{ margin: 0, paddingLeft: "20px", listStyle: "disc" }}>
//         {filteredEntries.map(([subKey, subValue], idx) => (
//           <li key={idx}>
//             <strong>{subKey}:</strong> {renderValue(subValue, url)}
//           </li>
//         ))}
//       </ul>
//     );
//   }

//   return value !== undefined && value !== null ? (
//     value.toString()
//   ) : (
//     <span className="empty-cell"></span>
//   );
// };

export default ProductsSpecs;
